declare global {
  interface Window {
    dataLayer: Array<Record<string, any>>;
  }
}

export type Nullable<T> = T | null;

export enum BRAND_LOGO_TYPE {
  DEFAULT = 'main',
  SQUARE = 'square-main',
  ICON = 'icon',
  NONE = 'none',
}

export enum ENVIRONMENT {
  DEV = 'dev',
  TST = 'tst',
  UAT = 'uat',
  PRD = 'prd',
}

export interface Languages {
  nl: string;
  eng: string;
}

// Mirrors brand-group.json element
export interface BrandGroupObject {
  id: string;
  brands: {
    id: string;
    name: string;
    consentId: string;
    urlDisplay: string;
    designSystem: {
      languages: Languages;
    };
    customerService: {
      languages: Languages;
    };
    privacyStatement: {
      languages: Languages;
    };
    readMore: {
      languages: Languages;
    };
  }[];
  userTracking: {
    enabled: boolean;
    containerId: string;
    type: string;
  };
}

export interface ApiErrorEntity {
  message: string;
  code: string;
}
export interface ApiError {
  body: object;
  errors: ApiErrorEntity[];
}
export class NotFoundError extends Error {}

export type BrandUrlsConfig = {
  [brand: string]: {
    [env in ENVIRONMENT]: string;
  };
};
